export default __webpack_public_path__ + "static/media/profile-hilya.c9858ab0.png";